import styled from "styled-components";


export const RecommendedSection = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

export const RecommendedSectionTitle = styled.h3`
  margin: 0 0 3% 0;
  font-size: 1.25rem;
  font-weight: bold;
  color: #000;
`;

export const RecommendedCarousel = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding: 1rem 0;
  scroll-snap-type: x mandatory;
  
  /* Style for Chrome, Safari and newer browsers */
  &::-webkit-scrollbar {
    height: 0.375rem; /* 6px */
    display: block;
  }

  &::-webkit-scrollbar-track {
    background: #fff1f6;
    margin: 0.5rem 0;
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fe2f67;
    border-radius: 0.25rem;
    border: 1px solid #fff;
    min-width: 5rem; /* 48px */
    &:hover {
      background-color: #d82c89;
    }
  }

  /* Style for Firefox */
  scrollbar-width: thin;
  scrollbar-color: #fe2f67 #fff1f6;
`;